module.exports = __webpack_public_path__ + "static/media/bell-fight1.eca4f9e2.aac";